import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context'
import { Link } from 'react-router-dom';
// import { Editor } from 'react-draft-wysiwyg';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import { EditorState } from 'draft-js';
import { EditorState } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
// import draftToHtml from 'draftjs-to-html';


function Report() {
  const [report, setReport] = useState()
  const [state, actions] = useContext(UserContext);
  let user = JSON.parse(String(localStorage.getItem('user')))
  const header = {Authorization: `JWT ${user.token}`}

  // const [title, setTitle] = useState()
  // const [content, setContet] = useState()

  // const editorToHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
  
  // const [editorToHtml, setEditorToHtml] = useState(EditorState.createEmpty())
  

  useEffect(()=>{
    async function fetchReportGet(){
      fetch(state.awslink + "/api/report/", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        // setEditorToHtml(JSON.parse(json[0].content))
        // console.log(EditorState.createWithContent(convertFromRaw(JSON.parse(json[0].content))))
        // console.log(draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(json[0].content))).getCurrentContent())))
        setReport(json)
        // setEditorToHtml(draftToHtml(convertToRaw(json[0]["content"].getCurrentContent())))
        
      }
      )
    }
    
    // if(ralist === null){
    //   console.log('fetch')
    //   if(state.token != undefined)
    fetchReportGet();
  }, [])

  console.log(report)
  // console.log(draftToHtml(convertToRaw(editorToHtml.getCurrentContent())))

  return(
    <Wrapper>
      <MidWrapper>
        {/* <IntroduceContent dangerouslySetInnerHTML={{__html: editorToHtml}}/> */}
        <Link to={"/recruiter/report/edit/add"}>글쓰기</Link>

        {report ? 
            report.length ?
            report.map((item, index)=>{
              console.log(index, item)
              return(
              <Card>
                
                <Link to={'/recruiter/report/'+ item.id }> </Link>
                <div>{item.title}</div>
              </Card>)
            }) : null
          :null}

      </MidWrapper>
    </Wrapper>   
  )
}

export default Report;


const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 135px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`


const MidWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 980px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: column;
`

// 생략..
// 변환시켜준 editorState 값을 넣기 위한 div 태그 css 
// const IntroduceContent = styled.div`
//   position: relative;
//   border: 0.0625rem solid #d7e2eb;
//   border-radius: 0.75rem;
//   overflow: hidden;
//   padding: 1.5rem;
//   width: 50%;
//   margin: 0 auto;
//   margin-bottom: 4rem;
// `;


const Card = styled.div`
  /* width: 25%; */
  width: 221px;
  /* max-width: 240px; */
  height: 220px;
  border: rgba(0,0,0,0.5) 2px solid;
  border-radius: 7px;
  margin: 10px;

  display: flex;
  /* flex-wrap: wrap; */
  /* flex-grow: 4; */
  justify-content: flex-start;
  
  align-items: flex-start;
  flex-direction: column;
  position: relative;

  
  
  :nth-child(5){
    /* background-color:green; */
    break-after: always;
  }
  >a{
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* z-index:2; */
  }
`